export {default} from './JumboCardQuick';